import { PrivacyContent } from './privacy-content';
import { PageScrollbar } from '@/shared/ui/page-scrollbar';

export function PrivacyPage() {
  return (
    <>
      <main>
        <PrivacyContent />
      </main>
      <PageScrollbar />
    </>
  );
}
